import React, { useCallback, useEffect, useState } from "react";
import { Avatar, Button, Col, Flex, Row } from "antd";
import Icon from "@ant-design/icons";
import { arrowIcon, DeleteRedBtn, EditIcon } from "../../assets/image/svg";
import moment from "moment";
import DrawerComponent from "../../components/DrawerComponent";
import FormComment from "./formComment";
import { useDispatch, useSelector } from "react-redux";
import { commentAll, commentDelete } from "../../store/bids";
import { RootState } from "../../store";
import Tooltips from "./tooltips";
import { RouteNames } from "../../router/routeNames";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

interface FormViewBetProps {
  dataRows?: any;
  setOpenDrawerContainer?: (value: boolean) => void;
  setOpenDrawerViewContainer?: (value: boolean) => void;
  setIsTypeForm?: (value: ((prevState: boolean) => boolean) | boolean) => void;
  typePage?: boolean;
}

const FormViewBet = ({
  dataRows,
  setOpenDrawerContainer,
  setOpenDrawerViewContainer,
  setIsTypeForm,
  typePage,
}: FormViewBetProps) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {t} = useTranslation();
  const [openDrawerComment, setOpenDrawerComment] = useState<boolean>(false);
  const dataCommentAll = useSelector((state: RootState) => state.bids.dataCommentAll);
  const [department, setDepartment] = useState<any>("");
  const [avatar, setAvatar] = useState<string | null>(null);
  const [avatarText, setAvatarText] = useState<string | null>(null);
  const [nameCountry1, setNameCountry1] = useState<string | null>(null);
  const [nameCountry2, setNameCountry2] = useState<string | null>(null);
  const [nameCity1, setNameCity1] = useState<string | null>(null);
  const [nameCity2, setMameCity2] = useState<string | null>(null);
  const { bet, symbol = '', bet_int } = dataRows?.[0] || {};
  const value = bet === null ? bet_int : bet;

  const handleAvatar = useCallback(() => {
    setAvatar(dataRows?.[0]?.users?.avatar);
    setAvatarText(dataRows?.[0]?.users?.fio.substring(0, 2).toUpperCase());
  }, [dataRows]);

  const closeFormViewComment = () => {
    setOpenDrawerComment(false);
  };

  const handleComment = () => {
    setOpenDrawerComment(true);
  };

  const handleDataRowsChange = useCallback(() => {
    if (dataRows.length > 0 && dataRows[0] !== null) {
      const currentId = dataRows[0].id;
      dispatch(commentAll({ id: currentId }));
      setDepartment(dataRows[0].department);
    } else {
      setDepartment(t('Sales'));
    }
  }, [dataRows]);

  useEffect(() => {
    handleDataRowsChange();
    handleAvatar();
    if (dataRows.length > 0) {
      setNameCountry1(
        dataRows?.[0]?.country1 !== null ? dataRows?.[0]?.country1 + "," : ""
      );
      setNameCity1(dataRows?.[0]?.city1 !== null ? dataRows?.[0]?.city1 : "");
      setNameCountry2(
        dataRows?.[0]?.country2 !== null ? dataRows?.[0]?.country2 + "," : ""
      );
      setMameCity2(dataRows?.[0]?.city2 !== null ? dataRows?.[0]?.city2 : "");
    }
  }, [handleDataRowsChange, handleAvatar]);

  const deleteComment = (id: number) => {
    dispatch(commentDelete({ id: id, bet_id: dataRows[0].id }));
  };

  const openFormNewComment = () => {
    if (setOpenDrawerContainer) {
      setOpenDrawerContainer(true);
    }
    if (setOpenDrawerViewContainer) {
      setOpenDrawerViewContainer(false);
    }
    if (setIsTypeForm) {
      setIsTypeForm(false);
    }
    setNameCountry1(null);
    setNameCountry2(null);
    setNameCity1(null);
    setMameCity2(null);
  };

  return (
    <>
      <Flex
        justify="space-between"
        className={
          typePage && location.pathname !== RouteNames.ARCHIVE
            ? "header-bet_new_view"
            : "header-bet_new"
        }
        align={"center"}
      >
        <div className={"fz-20"}>{t('Viewing')}</div>
        {typePage && location.pathname !== RouteNames.ARCHIVE && (
          <Button
            icon={<EditIcon />}
            type="text"
            onClick={openFormNewComment}
          />
        )}
      </Flex>
      <Flex gap={45} vertical className={"content__bet"}>
        <Flex vertical gap={24}>
          <div className={"fz-16"}>{dataRows?.[0]?.department}</div>
          <div className="location-selector">
            <Tooltips
              title={
                nameCountry1 || nameCity1
                  ? `${nameCountry1} ${nameCity1}`
                  : null
              }
            >
              <div className="location-box">
                <div className="location-title">{t('Location1')}</div>
                <div className="location-value">{dataRows?.[0]?.city1}</div>
              </div>
            </Tooltips>
            {department === t('Rent') ||
            department === "" ? (
              <>
                <Icon component={arrowIcon} className={"icon__arrow_view"} />
                <Tooltips title={nameCountry2 + " " + nameCity2}>
                  <div className="location-box">
                    <div className="location-title">{t('Location2')}</div>
                    <div className="location-value">{dataRows?.[0]?.city2}</div>
                  </div>
                </Tooltips>
              </>
            ) : null}
          </div>
          <Row justify={"space-between"} gutter={[32, 3]}>
            {department === t('Rent') ||
            department === t('Terminals') ||
            department === "" ? (
              <Col span={8}>
                <div className="location-title">{t('CpcNumber')}</div>
                <div className="location-value">
                  {dataRows?.[0]?.col_ktk}
                </div>
              </Col>
            ) : null}
            <Col span={8}>
              <div className="location-title">{t('ContainerType')}</div>
              <div className="location-value">{dataRows?.[0]?.type_ktk}</div>
            </Col>
            <Col span={8}>
              <Tooltips title={dataRows?.[0]?.bet === null ? dataRows?.[0]?.bet_int : dataRows?.[0]?.bet}>
                <div className="location-title">{t('Bet')}</div>
                <div className="location-value">
                  {value !== 'По запросу' && symbol != null ? `${value}${symbol}` : value}
                </div>
              </Tooltips>
            </Col>
          </Row>
          <Row justify={"space-between"} gutter={[32, 3]}>
            {department !== t('Rent') ||
            department === t('Terminals') ||
            department === "" ? (
              <Col span={8}>
                <div className="location-title">{t('Quality')}</div>
                <div className="location-value">{dataRows?.[0]?.quality}</div>
              </Col>
            ) : null}
            {department === t('Rent') ||
            department === t('Terminals') ||
            department === "" ? (
              <>
                <Col span={8}>
                  <div className="location-title">{t('FreeDays')}</div>
                  <div className="location-value">
                    {dataRows?.[0]?.free_days}
                  </div>
                </Col>
                <Col span={8}>
                  <div className="location-title">{t('Overdue')}</div>
                  <div className="location-value">{dataRows?.[0]?.cnp}</div>
                </Col>
              </>
            ) : null}
          </Row>
        </Flex>
        <Flex vertical gap={8}>
          <Flex justify={"space-between"} align={"center"}>
            <div className={"fz-14"}>{t('Comments')}</div>
            <div className={"text__blue"} onClick={handleComment}>
              {t('ViewAll')} ({dataCommentAll.length})
            </div>
          </Flex>
          <div
            className={"comment-selector"}
            style={
              dataCommentAll.length > 0 ? { maxHeight: 56 } : { minHeight: 56 }
            }
          >
            {dataCommentAll.length > 0 && (
              <Row className={"comment-wrapper"} justify={"end"}>
                <Col span={2}>
                  <Avatar size={32} src={avatar}>
                    {avatar === null ? avatarText : dataCommentAll?.[0]?.users?.fio.slice(0, 2).toUpperCase()}
                  </Avatar>
                </Col>
                <Col span={19}>
                  <Flex gap={6} vertical>
                    <div className={"fz-14"}>
                      {dataCommentAll?.[0]?.users?.fio}
                    </div>
                    <div className={"fz-12"}>{dataCommentAll?.[0]?.text}</div>
                  </Flex>
                </Col>
                <Col span={3}>
                  <Flex gap={6} align={"center"} justify={"end"}>
                    <div className={"text__date"}>
                      {moment(dataCommentAll?.[0]?.created_at).format(
                        "DD.MM.YYYY"
                      )}
                    </div>
                    {typePage && (
                      <Icon
                        component={DeleteRedBtn}
                        onClick={() => deleteComment(dataCommentAll?.[0]?.id)}
                      />
                    )}
                  </Flex>
                </Col>
              </Row>
            )}
          </div>
        </Flex>
      </Flex>
      <DrawerComponent open={openDrawerComment} onClose={closeFormViewComment}>
        <FormComment
          dataRows={dataRows}
          setOpenDrawerContainer={setOpenDrawerContainer}
        />
      </DrawerComponent>
    </>
  );
};

export default FormViewBet;
